// extracted by mini-css-extract-plugin
export default {"EventFormFooter":"EventFormFooter_EventFormFooter__HLPbd"};